import { inject, Injectable, Injector, signal } from '@angular/core';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, filter, switchMap } from 'rxjs';
import { HEADER_REPOSITORY } from './header.token';

@Injectable({ providedIn: 'root' })
export class HeaderStateService {
  readonly dropdownOpen = signal<string | null>(null);
  private readonly repository = inject(HEADER_REPOSITORY);
  private readonly translateService = inject(TranslateService);
  private readonly injector = inject(Injector);

  private readonly _langTypeAfterInit = new BehaviorSubject<boolean>(false);

  readonly langType = signal<string>('ID');

  readonly headerData = toSignal(
    this._langTypeAfterInit.pipe(
      filter((ready) => ready),
      switchMap(() => toObservable(this.langType, { injector: this.injector })),
      switchMap((langType) => {
        return this.repository.getMenuheader(langType === 'EN');
      })
    ),
    { initialValue: null }
  );

  init(): void {
    this._langTypeAfterInit.next(true);
  }

  setLanguage(lang: string): void {
    const langType = lang.toUpperCase();
    this.langType.set(langType);
    this.translateService.use(lang);
  }

  openDropdown(name: string) {
    this.dropdownOpen.set(name);
  }

  closeDropdown() {
    this.dropdownOpen.set(null);
  }
}
